import { ReactNode, useMemo, useState } from 'react';
import { BreadcrumbsContext } from './BreadcrumbsContext';
import { BreadcrumbItem } from '@oniratec/onira-react-ui';

export function BreadcrumbsProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<BreadcrumbItem[]>([]);

  const value = useMemo(() => ({ items, setItems }), [items]);

  return <BreadcrumbsContext.Provider value={value}>{children}</BreadcrumbsContext.Provider>;
}
